import React, {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { Box, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { generateApiPath } from 'src/utils';
import ModalDialog, {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { useForm } from 'src/components/Form';
import { AlertType, useAlert } from 'src/components/AlertsProvider';
import { useStoreUnitActions } from 'src/redux/helpers';
import solutionsStore, {
  useSolutionMappingFileDestinationOptions,
  useSolutionMappingFileOptions,
} from '../../redux';
import { SolutionOmniverseApp } from '../../types';
import { getSolutionOmniverseAppFormFields } from './SolutionOmniverseAppFormField';

interface DisplayData {
  key?: any;
  value: any;
  schema?: string;
}

type Props = {
  item?: SolutionOmniverseApp;
  title: string;
  loading?: boolean;
  open: boolean;
  onClose: ModalCloseHandler;
  onSubmit: (values: SolutionOmniverseApp) => void;
  confirmBtnText?: string;
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  overflowY: 'auto',
  alignItems: 'center',
  padding: '10px',
};

function SolutionOmniverseEditModal({
  item,
  title,
  loading,
  open,
  onClose,
  onSubmit,
  confirmBtnText = 'Create',
}: Props) {
  const actions = useStoreUnitActions(solutionsStore);
  const { showAlert } = useAlert();
  const { solutionId } = useParams();

  // const fields = useMemo(() =>
  //   getSolutionOmniverseAppFormFields
  // );

  const [form, handleSubmit] = useForm({
    visibleValuesOnly: true,
    fields: getSolutionOmniverseAppFormFields(),
    values: item,
    onSubmit,
    sx: containerStyle,
  });

  return (
    <ModalDialog
      open={open}
      title={title}
      confirmBtnText={confirmBtnText}
      loading={loading}
      onClose={onClose}
      maxWidth="md"
      titleStyle={{ height: '67px' }}
      actionsStyle={{ height: '87px' }}
      showCancelBtn={false}
      showConfirmBtn={false}
      contentStyle={{ paddingRight: '0px' }}
      fullWidth
    >
      {form}
      <Box textAlign="right" mt={3} style={{ paddingRight: '20px' }}>
        <Button onClick={onClose} variant="outlined" sx={{ mr: 2 }}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained">
          {!item ? 'Create' : 'Save'}
        </Button>
      </Box>
    </ModalDialog>
  );
}

export default SolutionOmniverseEditModal;
